import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2195">
      <About data-id="element-2196" />
    </main>;
}